import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Field,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from "../../../design-system";
import { terminateContract } from "../../../helpers/kronaly_helper";

const todayYmd = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const TerminateContractModal = ({ open, contract, onClose, onTerminated }) => {
  const [endDate, setEndDate] = useState(todayYmd());
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setEndDate(todayYmd());
      setError(null);
    }
  }, [open]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!contract?.id) return;
    setSaving(true);
    setError(null);
    try {
      const r = await terminateContract(contract.id, { end_date: endDate });
      onTerminated(r?.data ?? r);
      onClose();
    } catch (err) {
      setError(typeof err === "string" ? err : err?.message || "No se pudo cerrar el contrato.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Terminar contrato" size="md">
      <form onSubmit={onSubmit}>
        <ModalBody>
          {error && <div className="kr-mb-3"><Alert tone="danger">{error}</Alert></div>}
          <p className="kr-text-muted kr-mb-3">
            Se establecerá la fecha de fin del contrato. Si el terms vigente está abierto, se
            cerrará a la misma fecha.
          </p>
          <Field label="Fecha de fin" required>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              required
            />
          </Field>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" type="button" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="danger" type="submit" disabled={saving}>
            {saving && <Spinner size={12} color="#fff" />}
            Terminar contrato
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default TerminateContractModal;
